export const POSITION_FLAG = {
  POSITION: 'position',
  EDUCATION: 'education',
};

export const CONNECT_STATUS = {
  CONNECTED: 'Connected',
  NOT_CONNECTED: 'NotConnected',
  REQUIRE_ACTION: 'RequireAction',
  REQUIRE_APPROVE: 'RequireApprove',
};
